import React from "react";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function LoaderRow(props: Props) {
  return (
    <React.Fragment>
      <div className={styles.resourceCell}>
        <Skeleton className={styles.avatar} />
        <div className={styles.identity}>
          <Skeleton className={styles.name} />
          <Skeleton className={styles.profession} />
        </div>
      </div>
      {Array.from({ length: props.columns }, (_, index) => (
        <div key={index} className={styles.cell}>
          <Skeleton className={styles.cellBar} />
        </div>
      ))}
    </React.Fragment>
  );
}

export { LoaderRow };
